import { Box, Button, Typography, useTheme } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useErrorBoundary, type FallbackProps } from "react-error-boundary";

export const ClientErrorFallback = ({
  resetErrorBoundary,
  error,
}: FallbackProps) => {
  const { palette } = useTheme();
  const { resetBoundary } = useErrorBoundary();

  console.error("ClientErrorFallback Details", JSON.stringify(error, null, 2));

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "clamp(200px, 50%, 400px)",
          gap: "1rem",
        }}
      >
        <ErrorOutlineIcon
          style={{
            color: palette.primary.main,
            fontSize: "3rem",
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            color: palette.primary.main,
          }}
          variant="text_lg_m"
        >
          Oops we’ve encountered a problem
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: palette.primary.main,
          }}
          variant="text_sm_r"
        >
          Your browser may be out of date or not supported. Please check to make
          sure you are using Google Chrome, Microsoft Edge, Safari, or Firefox,
          and have the latest version installed.
        </Typography>

        <Button
          onClick={() => {
            if (typeof resetErrorBoundary === "function") {
              resetErrorBoundary();
            } else {
              resetBoundary();
            }
          }}
          sx={{
            display: "flex",
            gap: "0.25rem",
            alignItems: "center",
          }}
          variant="contained"
        >
          <RefreshIcon />
          Refresh
        </Button>
      </Box>
    </Box>
  );
};
